import React, { useState } from 'react'
import { AiOutlineUnlock } from 'react-icons/ai'
import { HiKey } from 'react-icons/hi'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ButtonSubmit } from '../../../GlobalStyle'
import api from '../../../hooks/API'
import PasswordInput from '../../components/PasswordInput'
import BaseLogin from '../index'
import { IconInput, Infos, InputContainer, NewUser } from '../style'

const NewPassword = () => {
  const [password, setPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState()
  const { id, token } = useParams()
  const navigate = useNavigate()
  const handle = (e) => {
    e.preventDefault()
    api
      .resetPassword(id, token, { password, confirmPassword })
      .then(() => {
        toast.success('Senha alterada com sucesso')
        navigate('/login')
      })
      .catch((e) => {
        toast.error(e.message)
      })
  }

  return (
    <BaseLogin>
      <Infos>
        <AiOutlineUnlock />
        <h2>Redefinir senha</h2>
        <p>Digite sua nova senha para confirmar</p>
      </Infos>
      <InputContainer>
        <IconInput>
          <HiKey />
        </IconInput>
        <PasswordInput
          login={'login'}
          placeholder="Senha"
          onChange={(e) => setPassword(e.target.value)}
        />
      </InputContainer>

      <InputContainer>
        <IconInput>
          <HiKey />
        </IconInput>
        <PasswordInput
          login={'login'}
          placeholder="Confirmar senha"
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </InputContainer>

      <NewUser>
        <ButtonSubmit type="submit" onClick={handle}>
          Confirmar
        </ButtonSubmit>
      </NewUser>
    </BaseLogin>
  )
}

export default NewPassword
